<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label for="form-pass-additional-purpose" class="control-label">{{ inputLabel }}</label>
    <input
      v-model="inputValue"
      :disabled="disabled"
      id="form-pass-additional-purpose"
      autocomplete="off"
      class="form-control"
      @input="emit"
      @change="emit"
      @blur="emit"
    />
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import passSectionMixin from '../../../../mixins/application-form/passSectionMixin'
import passInputMixin from '../../../../mixins/application-form/passInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'ContractNumberInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin,
    passInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Номер договора'
    },

    inputName: {
      default: 'contract_number'
    },

    inputHint: {
      default: undefined
    }
  }
}
</script>
